const brokerageAudit = {
    path: '/',
    component: resolve => require(['@/pages/admin/brokerage_audit/brokerage_audit.vue'], resolve),
}

export default brokerageAudit